import { z } from 'zod'

export const BundleChapterRefSchema = z.object({
  macroId: z.string().min(1),
  subParaId: z.string().min(1),
})

export const BundleQuizQuestionSchema = z
  .object({
    id: z.string().min(1),
    stem: z.string().min(1),
    options: z.array(z.string()).min(2).max(6),
    correctOptionIdx: z.number().int().nonnegative(),
    rationale: z.string().optional(),
    // null quando il capitolo di riferimento non è disponibile (soft-fail)
    chapterRef: BundleChapterRefSchema.nullable(),
    // Provenienza della chiave (assente = bundle legacy pre-key-resolution)
    keySource: z.enum(['evidence', 'knowledge']).optional(),
    // Citazione testuale dal materiale che giustifica la chiave (solo keySource='evidence')
    evidenceQuote: z.string().optional(),
    // chunkId della citazione (solo keySource='evidence')
    evidenceChunkId: z.string().optional(),
  })
  .refine((q) => q.correctOptionIdx < q.options.length, {
    message: 'correctOptionIdx deve essere < options.length',
    path: ['correctOptionIdx'],
  })

export const BundleQuizSchema = z.object({
  schemaVersion: z.number().int(),
  questions: z.array(BundleQuizQuestionSchema),
})

export type BundleChapterRef = z.infer<typeof BundleChapterRefSchema>
export type BundleQuizQuestion = z.infer<typeof BundleQuizQuestionSchema>
export type BundleQuiz = z.infer<typeof BundleQuizSchema>
